'use client';

import { INTERVIEW_SLOT_SELECTION_DROPDOWN_LABEL, getSlotSelectionOption } from '@/constants/interview-slot-selection.constant';
import { Autocomplete, Avatar, ListItem, ListItemAvatar, ListItemIcon, ListItemText, TextField } from '@mui/material';
import { useState } from 'react';
export const SlotSelectionField = ({
  value,
  onChange,
  options,
  disabled = false,
  size = 'small',
  label,
  placeholder = INTERVIEW_SLOT_SELECTION_DROPDOWN_LABEL,
  className,
  sx,
  inDialog = false
}) => {
  const selectedOption = value ? getSlotSelectionOption(value) ?? null : null;
  const [listboxOpen, setListboxOpen] = useState(false);
  const handleChange = (_event, newValue) => {
    setListboxOpen(false);
    document.activeElement?.blur();
    // Defer so the listbox unmounts before any dialog opened by the parent.
    queueMicrotask(() => onChange(newValue?.value ?? null));
  };
  return <Autocomplete size={size} className={className} sx={sx} options={options} value={selectedOption} disabled={disabled} open={listboxOpen} onOpen={() => setListboxOpen(true)} onClose={() => setListboxOpen(false)} openOnFocus getOptionLabel={option => option.title} isOptionEqualToValue={(option, selected) => option.value === selected.value} onChange={handleChange} slotProps={{
    popper: {
      // Keep listbox in the dialog stacking context when embedded in modals.
      ...(inDialog ? {
        disablePortal: true
      } : {
        // Escape interview table overflow-x-auto so long option text isn't clipped.
        popperOptions: {
          strategy: 'fixed'
        }
      }),
      modifiers: [{
        name: 'slotDropdownWidth',
        enabled: true,
        phase: 'beforeWrite',
        requires: ['computeStyles'],
        fn: ({
          state
        }) => {
          const anchorWidth = state.rects.reference.width;
          state.styles.popper.minWidth = `${Math.max(anchorWidth, 256)}px`;
          state.styles.popper.width = 'auto';
          state.styles.popper.maxWidth = 'min(90vw, 28rem)';
        }
      }, {
        name: 'preventOverflow',
        enabled: true,
        options: {
          padding: 8,
          boundary: 'viewport',
          altAxis: true
        }
      }],
      sx: {
        width: 'auto !important',
        zIndex: inDialog ? 1 : theme => theme.zIndex.modal - 1
      }
    },
    paper: {
      sx: {
        width: 'max-content',
        minWidth: '100%',
        maxWidth: 'min(90vw, 28rem)',
        overflow: 'visible'
      }
    },
    listbox: {
      sx: {
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        overflowX: 'hidden',
        overflowY: 'auto'
      }
    }
  }} renderOption={(props, option) => {
    const {
      key,
      ...optionProps
    } = props;
    return <ListItem key={key} {...optionProps} component="li" dense disablePadding disableGutters sx={{
      alignItems: 'flex-start'
    }}>
                        <ListItemAvatar className="min-w-0! -ml-2! mr-2! shrink-0!">
                            <Avatar className="size-8! bg-accent! border! border-divider!">
                                <option.icon className="size-4 text-accent-foreground!" />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText className="-my-0.25!" primary={option.title} secondary={option.subtitle} sx={{
        minWidth: 0
      }} primaryTypographyProps={{
        variant: 'body2',
        sx: {
          whiteSpace: 'normal'
        }
      }} secondaryTypographyProps={{
        variant: 'caption',
        component: 'div',
        sx: {
          whiteSpace: 'normal'
        }
      }} />
                    </ListItem>;
  }} renderInput={params => <TextField {...params} label={label} placeholder={selectedOption ? undefined : placeholder} size={size} />} />;
};